import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
	emailSchedulerControllerCreateScheduleMutation,
	emailSchedulerControllerListSchedulesQueryKey,
} from '@dealstack/shared/lib/backendClient/@tanstack/react-query.gen';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';

export const useCreateScheduledEmail = ({
	dealId,
	programmeId,
}: {
	dealId: string;
	programmeId: string;
}) => {
	const tMipManage = useTranslationMipManage();
	const queryClient = useQueryClient();

	const mutation = useMutation({
		...emailSchedulerControllerCreateScheduleMutation(),
		onSuccess: async () => {
			showToastV2({
				state: 'success',
				title: tMipManage('email_scheduler.toast.start.successful'),
			});
			await queryClient.invalidateQueries({
				queryKey: emailSchedulerControllerListSchedulesQueryKey({
					path: { dealId, programmeId },
				}),
			});
		},
		onError: () => {
			showToastV2({ state: 'error', title: tMipManage('email_scheduler.toast.start.error') });
		},
	});

	return {
		startReminders: (documentWorkflowInstanceId: string) =>
			mutation.mutate({
				path: { dealId, programmeId },
				body: { documentWorkflowInstanceId },
			}),
		isPending: mutation.isPending,
	};
};
